



























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import { useThemeStore } from "@/shared/store/theme";

@Component
export default class SchedulePersonalContributionCancelModal extends Vue {
  themeStore = useThemeStore();

  @Prop({ required: true })
  cancelModalVisible: boolean;

  @Prop()
  displaySameDayContributionWarning: boolean;

  today = moment().format("MMM, DD YYYY");

  onCancel (): void {
    this.$emit("cancel");
  }

  onSubmit (): void {
    this.$emit("confirm-cancellation");
  }
}
